import React from 'react';
import { Button, Icon } from '@digitools/honest-ui';
import PrintOutlined from '@mui/icons-material/PrintOutlined';
import useAuthentication from "src/hooks/useAuthentication";
import { downloadAsConfirmationPdf } from "../../api/ApiCalls";
import useTranslate from 'src/hooks/useTranslate';
import useExperience from 'src/hooks/useExperience';
import useAsCustomerConfigContext from '../../hooks/useAsConfigContext';
import useAsDataContext from '../../hooks/useAsDataContext';
import { getAsRequest } from '../../utils/AsDataUtils';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import useTealium from 'src/hooks/useTealium';
import ConfirmationText from './confirmationText';
const DownloadAndPrint = (props) => {
    const { setErrorMessage } = props;
    const { t } = useTranslate();
    const { authHeader } = useAuthentication();
    const { language, experienceCode } = useExperience();
    const { claimantData, conditionData, accommodationRequestDataArray, documents, accommodationResponse } = useAsDataContext();
    const { asConfig } = useAsCustomerConfigContext();
    const { trackEvent } = useTealium();
    const pdfObj = {
        accommodationResponse,
        claimantData,
        accommodationRequestDataArray: accommodationRequestDataArray && getAsRequest(accommodationRequestDataArray),
        conditionData,
        documents: documents.map((doc) => ({
            uuid: doc.docId,
            name: doc.documentName,
        })),
        language: language,
        experience: experienceCode,
        asConfig: asConfig?.config,
    };
    const trackPageEvent = () => {
        trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.DOWNLOAD,
            event_name: 'view and print submission',
            event_type: TEALIUM_EVENT.EVENT_TYPE.ACCOMMODATION,
            event_status: TEALIUM_EVENT.EVENT_STATUS.START,
        });
    };
    return (<Button type='secondary' label={t(ConfirmationText.printOption)} 
    // honest-ui has no printer icon, so use Material's through the honest-ui Icon adapter (same pattern as Header.tsx)
    icon={<Icon component={PrintOutlined}/>} iconSize={20} onClick={() => {
            trackPageEvent();
            downloadAsConfirmationPdf(authHeader(), pdfObj, setErrorMessage, t(ConfirmationText.downloadErrorText));
        }} data-testid={'download-button'}/>);
};
export default DownloadAndPrint;
